<template>
<div id="pop-wrapper" v-if="show_login">
    <div id="pop-dark"></div>
      <div class="popup-signup popup" >
          <a class="close" @click="$emit('close')"></a>
        <div class="pop-up-signup-content">
          <div class="logo"></div>
            <div id="media-personnel-login" v-if="!show_signup">
                        <h1>כניסת אנשי מדיה</h1>
          <h4 class="sub_title">עורכים, שדרים, עיתונאים, תקליטנים וכד'</h4>

              <form class="singer-login-form" @submit.prevent="login()">
                <input type="email" name="email" placeholder="דוא”ל" ref="login_username" class="form-control" required="">
                <input type="password" name="password" placeholder="סיסמא" ref="login_password" class="form-control" required="">
                <input type="hidden" id="singer_login_user_nonce_field" name="singer_login_user_nonce_field" value="a343bb2c6e"><input type="hidden" name="_wp_http_referer" value="/songs/%D7%90%D7%95%D7%93%D7%9C%D7%99%D7%94-2018/?key=757365723d61646d696e6973747261746f7226706f73745f69643d3130353936">                <input type="hidden" name="user_type" value="media_personnel">
                <input type="hidden" name="abredirectto" value="https://mysong.co.il/songs/%D7%90%D7%95%D7%93%D7%9C%D7%99%D7%94-2018">
                <div><input type="submit" value="הכנס" class="btn"></div>
                <a class="sm_text fancy" href="/signup/media_forgotPass" target="_blank" id="forget_pass">שכחתי סיסמה</a>
                <p style="display:none;" class="popbtp">אפשר לצאת לדרך בשיחה איתנו: 03-5258267<br>שעות הפעילות: א’-ה’ בין 09:00 ל - 17:00<br>או <a class="ab-on-page-navigation" @click="show_signup=true">להרשם לאתר</a> ואנו ניצור קשר בהקדם האפשרי</p>
                <div style="margin-top:40px">
                  <div><span class="sm_text">עדיין לא רשומים?</span></div>
                  <a class="ab-on-page-navigation" @click="show_signup=true">להרשם לאתר</a>
                </div>
              </form>
            </div><!-- /.ab-on-page-navigation -->
            <div id="media-personnel-registration" class="media-personnel-registration" v-if="show_signup">
                        <h1>הרשמת אנשי מדיה</h1>
          <h4 class="sub_title">עורכים, שדרים, עיתונאים, תקליטנים וכד'</h4>

                  <form @submit.prevent="signup()" class="singer-registration-form" data-submit-url="https://mysong.co.il/wp-admin/admin-ajax.php">
                    <div class="col-md-6 col-xs-12"><input ref="signup_name" type="text" placeholder="שם מלא" name="name" class="form-control fname req" data-toggle="tooltip" data-placement="bottom" title="חובה למלא שדה זה" data-animation="true" data-trigger="manual"></div>
                    <div class="col-md-6 col-xs-12"><input ref="signup_phone" type="text" placeholder="טלפון" name="phone" class="form-control req" data-toggle="tooltip" data-placement="bottom" title="חובה למלא שדה זה" data-animation="true" data-trigger="manual"></div>
                    <div class="col-md-6 col-xs-12"><input ref="signup_email" type="email" placeholder="אימייל" name="email" class="form-control req" data-toggle="tooltip" data-placement="bottom" title="חובה למלא שדה זה" data-animation="true" data-trigger="manual"></div>
                    <div class="col-md-6 col-xs-12"><input ref="signup_publisher" type="text" placeholder="שם ערוץ מדיה" name="publisher" class="form-control mediachannelname req" data-toggle="tooltip" data-placement="bottom" title="חובה למלא שדה זה" data-animation="true" data-trigger="manual"></div>
                    <div class="clr"></div>
                    <input type="submit" value="הרשם" class="btn">
                    <div class="row">
                      <div class="col-xs-12">

                        <div><a class="abab-on-page-navigation  ab-on-page-navigation" @click="show_signup=false">חזור   &gt;</a></div>
                      </div> <!--  .col-xs-12 -->
                    </div> <!--  .row -->
                  </form>
            </div><!-- /.ab-on-page-navigation signupform -->
            
          </div> <!--  .pop-up-signup-content -->
        </div>
</div>
</template>
<style scoped>
.singer-login-form .btn{background-color: #cc3538;}
.singer-registration-form .btn{background-color: #cc3538;}
.singer-registration-form .abab-on-page-navigation{color: #cc3538;}
.singer-login-form .ab-on-page-navigation{color: #cc3538;}
</style>

<script>
export default {
  props: ["widgets", "item"],
  data(){
      return {
          show_signup: false,
          show_login: true
      }
  },
  created(){
    
    
  },
  methods:{
    login(){
            this.$http.post(window.api_url + 'login', {username:  this.$refs.login_username.value, password:  this.$refs.login_password.value}).then(function(data){
      
              if (data.data.data == true) document.location = document.location.href;
              else alert('פרטי ההתחברות אינם נכונים.');
            });


    },
    signup(){

          if (this.$refs.signup_name.value == '') { alert('נא למלא שם מלא'); return false; }
          if (this.$refs.signup_phone.value == '') { alert('נא למלא טלפון'); return false; }
          if (this.$refs.signup_email.value == '') { alert('נא למלא אי-מייל'); return false; }

          this.$http.post(window.api_url + 'signup', {name:  this.$refs.signup_name.value, phone: this.$refs.signup_phone.value, email: this.$refs.signup_email.value, publisher: this.$refs.signup_publisher.value, }).then(function(){
    
              alert('פרטיך נשמרו בהצלחה. נחזור אליך בהקדם.');

              this.$emit('close');

    
          });


    }
  }
}
</script>